// The plain-English rules and vocabulary for chat messages, loaded from the
// server once per page (see promptMask.js and server/ai/plainText.js).
import { getAiTextRules } from "../../../api/aiServices";
import { compileRules } from "./promptMask";

let loading = null;

export const loadTextRules = () => {
  if (!loading) {
    loading = getAiTextRules()
      .then(compileRules)
      .catch((error) => {
        loading = null;
        throw error;
      });
  }
  return loading;
};
